import { TrendingUp } from 'lucide-react';
import { DocPage } from '@/components/investor';
import { investorsSections, investorsStatus, investorsSummary, investorsTop } from '@/content/investors';
import { SITE } from '@/lib/site';

/** Public investor overview, linked from the footer. Content mirrors docs/investors/fnk/investors.md. */
export function InvestorsPage() {
  return (
    <DocPage
      badgeIcon={TrendingUp}
      badge="For Investors"
      title="The AI stack, the Harness and the inference underneath enterprise AI."
      status={investorsStatus}
      summary={investorsSummary}
      top={investorsTop}
      sections={investorsSections}
      contactEmail={SITE.investors}
      footer="Ask for the deck and the benchmark bundle. Financial scenarios and the funding model are shared on request."
    />
  );
}
